
import { mixins, Options } from 'vue-property-decorator'

import { findElement, findElements, getInnerHtml, parseFromString, runWidgetScripts } from '../../utils'
import { FetchHtmlContentMixin } from '../mixins'
import WidgetMixin, { WidgetMeta } from './WidgetMixin'
import WidgetStyleMixin from './WidgetStyleMixin'

export const meta: WidgetMeta = {
  label: 'HTML content widget',
  groups: {
    style: 'Beállítás'
  },
  defaultGroup: 'style',
  fields: {
    htmlTemplate: {
      type: 'textarea',
      default: 'https://storage-live.rtl.hu/asset/bank360/index.html',
      props: {
        label: 'URL vagy HTML',
        placeholder: 'URL vagy HTML',
        autoHeight: true
      }
    }
  }
}

@Options({
  name: 'HtmlContentWidget'
})
export default class HtmlContentWidget extends mixins(WidgetMixin, WidgetStyleMixin, FetchHtmlContentMixin) {
  get nodes () {
    return (this.htmlContentData && this.htmlContentData.textResponse) ? parseFromString(this.htmlContentData.textResponse) : null
  }

  get content () {
    if (this.nodes) {
      const body = findElement(this.nodes, 'body')
      const head = findElement(this.nodes, 'head')

      if (body) {
        const imgs = body?.getElementsByTagName('img')
        for (const img of imgs) {
          if (!img.hasAttribute('loading')) {
            img.setAttribute('loading', 'lazy')
          }
        }
      }

      const result: {template: string | null, styles: Array<string>} = {
        template: getInnerHtml(body),
        styles: (head ? findElements(Array.from(head.childNodes), 'link') : []).filter((n) => (n as HTMLLinkElement).getAttribute('rel') === 'stylesheet').map(link => (link as HTMLLinkElement).href)
      }
      return result
    }
    return null
  }

  runScripts () {
    const el = this.$refs.content as HTMLDivElement | null
    if (el) {
      runWidgetScripts(el)
    }
  }

  serverPrefetch () {
    return this.fetchHtmlContent().then(() => {
      this.runScripts()
    })
  }

  mounted () {
    this.fetchHtmlContent().then(() => {
      this.runScripts()
    })
  }
}
